/// <amd-module name="typeahead/features/PageloadMetricsLogger" />
import {ClientHandlerRegistry} from "typeahead/client/ClientHandlerRegistry";
import TypeaheadErrorLogger from "typeahead/core/logging/TypeaheadErrorLogger";
import {SubmitClickedMessage} from "typeahead/core/message/SubmitClickedMessage";
import {SuggestionShownMessage} from "typeahead/core/message/SuggestionShownMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

interface IPageLoadMetrics {
    name: string;
    utaBundle: string;
    durationInMillisFromStorefrontScriptStartToUtaScriptStart: number;
    durationInMillisFromUtaScriptStartToUtaReady: number;
    durationInMillisFromStorefrontScriptStartToInputFocus: number;
    durationInMillisFromUtaReadyToUtaPageLoadHandler: number;
    isReadyOnFocus: boolean;
    numberOfInputInteractions: number;
    suggestionsRenderTimeInMillis: number;
    tab: string;
    domElementId: string;
}
export class PageloadMetricsLogger implements IPageLoadHandler {
    private isMetricsLogged: boolean = false;

    public handlePageLoad(options: any, context: IContext): void {
        this.evaluateMetrics();
    }

    private evaluateMetrics() {
        const pageLoadHandlerExecutionTimestamp = Date.now();
        const metrics: IPageLoadMetrics = {} as IPageLoadMetrics;
        metrics.name = "UtaPageloadMetrics";
        metrics.utaBundle = TypeaheadUtils.getUtaBundleUrl();
        metrics.numberOfInputInteractions = 0;

        metrics.durationInMillisFromStorefrontScriptStartToUtaScriptStart =
            (!isNaN(window.storefrontScriptLoadingStartedTimestamp) &&
            !isNaN(window.utaScriptLoadingStartedTimestamp)) ?
                (window.utaScriptLoadingStartedTimestamp - window.storefrontScriptLoadingStartedTimestamp) : undefined;

        metrics.durationInMillisFromUtaScriptStartToUtaReady =
            (!isNaN( window.utaModuleReadyTimeStamp) && !isNaN(window.utaScriptLoadingStartedTimestamp)) ?
                (window.utaModuleReadyTimeStamp - window.utaScriptLoadingStartedTimestamp) : undefined;

        metrics.durationInMillisFromUtaReadyToUtaPageLoadHandler =
            (!isNaN(pageLoadHandlerExecutionTimestamp) && !isNaN(window.utaModuleReadyTimeStamp)) ?
                (pageLoadHandlerExecutionTimestamp - window.utaModuleReadyTimeStamp) : undefined;

        $("body").one("focus", "[data-provide=utypeahead]", () => {
            const focusTimestamp = Date.now();
            metrics.durationInMillisFromStorefrontScriptStartToInputFocus =
                !isNaN(window.storefrontScriptLoadingStartedTimestamp) ?
                    focusTimestamp - window.storefrontScriptLoadingStartedTimestamp : undefined;
        });

        $("body").on("input.typeahead_metrics", "[data-provide=utypeahead]", () => {
            metrics.numberOfInputInteractions++;
        });

        const tokenSuggestionShown = TypeaheadMessage.subscribe(
            SuggestionShownMessage.getTopic(), (topic: string, message: SuggestionShownMessage) => {
                metrics.domElementId = message.getDomElementId();
                metrics.suggestionsRenderTimeInMillis = message.getRenderTime();
                TypeaheadMessage.unsubscribe(topic, tokenSuggestionShown);
                this.logMetrics(metrics);
            });

        const tokenSubmitClicked = TypeaheadMessage.subscribe(
            SubmitClickedMessage.getTopic(), (topic: string, message: SubmitClickedMessage) => {
                TypeaheadMessage.unsubscribe(topic, tokenSubmitClicked);
                this.logMetrics(metrics);
            });
    }

    private logMetrics(metrics: IPageLoadMetrics) {
        if (!this.isMetricsLogged) {
            metrics.tab = ClientHandlerRegistry.getTab();
            metrics.isReadyOnFocus = !window.isUtaModuleNotReadyOnFocus;
            TypeaheadErrorLogger.log(undefined, undefined, undefined, metrics);
            this.isMetricsLogged = true;
            $("body").off("input.typeahead_metrics");
            if (window.utaDebug) {
                console.dir("uTA Pageload Metrics:" + JSON.stringify(metrics));
                console.dir(metrics);
            }
        }
    }
}
